import { render, staticRenderFns } from "./executive-badge.vue?vue&type=template&id=1ddad091&"
import script from "./executive-badge.vue?vue&type=script&lang=js&"
export * from "./executive-badge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports